module.exports = __webpack_public_path__ + "img/IT0001357130637.232c6612.png";